module.exports = __webpack_public_path__ + "b5b061d0380d33575e1b2c0847c915d5.png";